import { useCallback, useState } from 'react';
import { calcMonthlyMortgagePayment } from 'helpers/calculations';
import { unFormatCurrency } from 'helpers/money.helper';
import { isEmpty } from 'helpers/string.helper';
import { useComplexState, useUpdateCallback } from 'hook/helper.hook';

const termsList = ['15 Years', '30 Years'];

export const usePaymentCalculator = () => {
  const [states, setStates] = useComplexState({
    homePrice: null,
    downPayment: null,
    interestRate: null,
    monthlyPayment: 0,
    terms: termsList[0],
  });

  // isolated state
  const [calculateButtonDisabled, setCalculateButtonDisabled] = useState(true);

  const calculateFieldsEmpty = useCallback(() => {
    const amountValidations = !(
      parseInt(states.homePrice) > parseInt(states.downPayment) &&
      parseFloat(states.interestRate) > 0
    );
    setCalculateButtonDisabled(
      isEmpty(states.homePrice) ||
        isEmpty(states.downPayment) ||
        isEmpty(states.interestRate) ||
        amountValidations,
    );
  }, [states]);

  useUpdateCallback(() => {
    calculateFieldsEmpty();
  }, [states]);

  const handleCalculateMonthlyMortgageClick = () => {
    setStates({
      monthlyPayment: calcMonthlyMortgagePayment(
        states.homePrice,
        states.downPayment,
        states.interestRate,
        states.terms,
      ).toFixed(2),
    });
  };

  const onDownPaymentUpdate = e => {
    let val = unFormatCurrency(e.target.value);
    if (val === '' || /^[0-9]+$/i.test(val)) {
      setStates({
        downPayment: val,
      });
    }
  };

  const onInterestRateUpdate = e => {
    const value = e.target.value;
    const interestRateBelowCap = parseInt(value) <= 100;
    let interestRate;
    if (isEmpty(value)) {
      interestRate = value;
    } else if (/^$|^[.0-9]+$/i.test(value) && interestRateBelowCap) {
      if (parseInt(value) === 0 && !value.includes('.')) {
        interestRate = 0;
      } else {
        interestRate = value;
      }
    }
    setStates({
      interestRate,
    });
  };

  const onHomePriceUpdate = e => {
    let val = unFormatCurrency(e.target.value);
    if (val === '' || (/^[0-9]+$/i.test(val) && val.length < 16)) {
      setStates({
        homePrice: val,
      });
    }
  };

  const setTerms = value => {
    setStates({
      terms: value,
    });
  };

  return {
    ...states,
    termsList,
    calculateButtonDisabled,
    handleCalculateMonthlyMortgageClick,
    onDownPaymentUpdate,
    onInterestRateUpdate,
    onHomePriceUpdate,
    setTerms,
  };
};
